import React from "react";

const ObjectivesYTS = () => {
  const objectivesData = [
    {
      title: "Course Objectives:",
      items: [
        "Understand International Trade Fundamentals: Gain a solid foundation in the principles & theories underlying international trade.",
        "Navigate Trade Agreements: Learn to analyse & interpret trade agreements, assessing their implications for businesses & economies.",
        "Master Trade Negotiation Techniques: Acquire negotiation skills crucial for effective participation in international trade talks.",
        "Explore Emerging Trends: Stay updated on the latest developments & trends shaping global trade, including digitalization & sustainability.",
        "Develop Analytical Skills: Hone critical thinking & analytical abilities essential for assessing market opportunities & risks.",
      ],
      color: "text-green-600",
    },
    {
      title: "Course Outcomes:",
      items: [
        "Possess a thorough understanding of international trade dynamics & policies.",
        "Be proficient in analysing trade agreements & assessing their impact.",
        "Demonstrate effective negotiation skills in various trade scenarios.",
        "Stay abreast of emerging trends & innovations in global trade.",
        "Apply analytical skills to identify opportunities & challenges in international markets.",
      ],
      color: "text-purple-600",
    },
  ];
  return (
    <div className="my-10 " id="objectives">

      <div className="max-w-6xl mx-auto bg-sdbodywhite bg-opacity-70 shadow-lg rounded-lg p-8">


        <div className="md:flex md:gap-8 space-y-5 md:space-y-0">
          {objectivesData.map((section, index) => (
            <div key={index} className="md:w-1/2">
              <h3
                className={`text-lg md:text-2xl font-semibold mb-4 ${section.color}`}
              >
                {section.title}
              </h3>
              <ul className="space-y-4 list-disc list-inside">
                {section.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-4">
                    <img
                      src="/image-fix/pointers/inspiration-svgrepo-com.svg"
                      alt="icon"
                      className="w-8 h-8 mt-1"
                    />
                    <span className="text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ObjectivesYTS;
